import { useMutation } from '@tanstack/react-query';
import { Trash2 } from 'lucide-react';
import { useState } from 'react';
import { del, errorText } from '@/lib/api';
import { useT } from '@/lib/i18n';
import { Button, Dialog, ErrorBox } from './ui';

/** throw a draft version away (asked once more) — a published version has no such button: it is never deleted */
export function DeleteDraftButton({ path, label, onDeleted }: { path: string; label: string; onDeleted: (answer: unknown) => void }) {
  const t = useT();
  const [asking, setAsking] = useState(false);
  const remove = useMutation({ mutationFn: () => del<unknown>(path), onSuccess: (a) => onDeleted(a) });
  return (
    <>
      <Button variant="ghost" icon={<Trash2 size={14} />} onClick={() => setAsking(true)} className="text-red-700 hover:bg-red-50 hover:text-red-800">
        {t('Delete draft')}
      </Button>
      {asking && (
        <Dialog
          title={`${t('Delete draft')} — ${label}`}
          onClose={() => setAsking(false)}
          footer={
            <>
              <Button variant="secondary" onClick={() => setAsking(false)}>
                {t('Cancel')}
              </Button>
              <Button onClick={() => remove.mutate()} disabled={remove.isPending} className="bg-red-600 hover:bg-red-700">
                {t('Delete')}
              </Button>
            </>
          }
        >
          <p>{t('The draft and its changes are thrown away. Published versions and the clients on them are not touched.')}</p>
          {remove.error && <ErrorBox text={errorText(remove.error)} />}
        </Dialog>
      )}
    </>
  );
}
